
const industriesData = [
  {
    id: 1,
    slug: "fintech",
    title: "Crypto/Financial Services and Fintech",
    subtitle: "Crypto/Financial Services and Fintech",
    description:
      "Bridging the traditional and digital financial worlds with secure, scalable, and innovative crypto solutions.",
    detailedDescription:
      "The crypto industry involves digital assets and blockchain technology, presenting both innovative opportunities and unique challenges for traditional financial institutions and new ventures.",
    imagePosition: "left",
    link: "/industry/fintech",
    image: "/assets/images/600x400.webp",
    workProcess: {
      pillName: "Key Challenges",
      heading: "Why it matters / key challenges",
      processSteps: [
        {
          id: 1,
          title: "Secure & Compliant Integration",
          description: "Traditional banks face the challenge of integrating crypto services securely and compliantly, while new crypto businesses need robust, scalable platforms for transactions and client onboarding.",
          icon: "01"
        },
        {
          id: 2,
          title: "Scalable Transaction Platforms", 
          description: "Crypto businesses require robust platforms capable of handling high transaction volumes and seamless growth to meet market demands.",
          icon: "02"
        },
        {
          id: 3,
          title: "Innovative Digital Products",
          description: "Financial institutions need solutions that enable them to create novel digital products like USD bank accounts that double as crypto wallets.",
          icon: "03"
        }
      ],
      imageSrc: "/assets/images/Key Challenges.webp",
      parallaxElements: [
        {
          depth: "0.30",
          content: "Compliance & Security",
          type: "badge",
          color: "bg-[#4A7DFF]"
        },
        {
          depth: "0.40", 
          content: "/assets/images/Etherium.webp",
          type: "image"
        },
        {
          depth: "0.20",
          content: "Unified Customer Experience", 
          type: "badge",
          color: "bg-it-blue"
        }
      ]
    },
    features: {
      headerContent: {
        title: "How your company fits in",
        description: "Impera enables financial institutions to innovate in the crypto space by building integrated banking core solutions, crypto exchanges, and services, allowing them to create novel digital products like USD bank accounts that double as crypto wallets."
      },
      cards: [
        {
          id: 1,
          icon: "BankingIcon",
          title: "Bridging Traditional Banking and Crypto",
          description: "Impera integrates banking cores with crypto services to enable seamless financial innovation.",
          link: "/services",
          aosDelay: 0
        },
        {
          id: 2,
          icon: "FinancialIcon", 
          title: "Empowering Financial Institutions",
          description: "Helps banks and fintechs launch digital products like USD accounts that function as crypto wallets.",
          link: "/services",
          aosDelay: 200
        },
        {
          id: 3,
          icon: "InnovationIcon",
          title: "Driving Next-Gen Financial Solutions", 
          description: "Enables secure, compliant, and scalable infrastructure for the evolving digital asset ecosystem.",
          link: "/services",
          aosDelay: 400
        }
      ],
      backgroundImages: {
        mobile: "/assets/images/home-nine/features-card-bg-black.png",
        desktop: "/assets/images/home-nine/features-card-bg.svg"
      }
    },
    faqs: [
      {
        question: "Integrations between banking cores and crypto services",
        answer: "Seamless integration between traditional banking cores and crypto services for unified operations."
      },
      {
        question: "Real-time AI document analysis for onboarding",
        answer: "Real-time AI verification and analysis to streamline client onboarding."
      },
      {
        question: "Enhanced service and accelerated balance accreditation",
        answer: "Enhanced processing speed ensures quick service delivery and instant balance accreditation."
      },
      {
        question: "Real-time transaction processing capacity",
        answer: "Robust infrastructure enabling secure, real-time transaction handling at scale."
      },
      {
        question: "End-to-end workflow design and orchestration for client onboarding, compliance, trading, and treasury",
        answer: "Comprehensive workflow design covering onboarding, compliance, trading, and treasury management."
      },
      {
        question: "Institutional-grade custody, wallet management, and multi-signature security with Crypto Exchanges",
        answer: "Institutional-grade custody, multi-signature wallet management, and advanced crypto exchange security."
      }
    ]
  },
  {
    id: 2,
    slug: "logistics",
    title: "Logistics",
    subtitle: "Logistics",
    description:
      "Smarter, faster, and more connected logistics powered by automation and data-driven insights.",
    detailedDescription:
      "The logistics industry is the backbone of global trade, ensuring goods move efficiently from origin to destination. With rising customer expectations and complex supply chains, businesses need smarter systems to stay competitive.",
    imagePosition: "right",
    link: "/industry/logistics",
    image: "/assets/images/600x400-1.webp",
    workProcess: {
      pillName: "Key Challenges",
      heading: "Why it matters / key challenges",
      processSteps: [
        {
          id: 1,
          title: "Inefficient Last-Mile Delivery",
          description: "Logistics companies face challenges like inefficient last-mile delivery, siloed systems, lack of real-time visibility, and rising operational costs. Meeting delivery promises while optimizing cost and efficiency requires next-generation digital solutions.",
          icon: "01"
        },
        {
          id: 2,
          title: "Siloed Systems & Limited Visibility", 
          description: "Tracking shipments and delivery statuses across multiple disconnected systems creates delays and errors, preventing real-time visibility into operations.",
          icon: "02"
        },
        {
          id: 3,
          title: "Rising Operational Costs",
          description: "Without integrated systems and automation, logistics companies struggle to optimize routes, reduce costs, and improve overall efficiency.",
          icon: "03"
        }
      ],
      imageSrc: "/assets/images/industries/Key Challenge 2.webp",
      parallaxElements: [
        {
          depth: "0.30",
          content: "Operational Efficiency",
          type: "badge",
          color: "bg-[#4A7DFF]"
        },
        {
          depth: "0.40", 
          content: "/assets/images/industries/Etherium-1.webp",
          type: "image"
        },
        {
          depth: "0.20",
          content: "Data-Driven Decisions", 
          type: "badge",
          color: "bg-it-blue"
        }
      ]
    },
    features: {
      headerContent: {
        title: "How your company fits in",
        description: "Impera helps logistics companies transform operations with automation, ERP integrations, microservices, and data platforms."
      },
      cards: [
        {
          id: 1,
          icon: "BankingIcon",
          title: "ERP-Integrated Last Mile Systems",
          description: "Automated task dispatch and seamless operations integrated with your existing ERP infrastructure.",
          link: "/services",
          aosDelay: 0
        },
        {
          id: 2,
          icon: "Cloud", 
          title: "Real-Time Tracking & Analytics",
          description: "Comprehensive visibility into shipments, deliveries, and performance metrics across your entire network.",
          link: "/services",
          aosDelay: 200
        },
        {
          id: 3,
          icon: "Workflow",
          title: "Microservices Architecture", 
          description: "Scalable, flexible systems that grow with your business and adapt to changing logistics requirements.",
          link: "/services",
          aosDelay: 400
        }
      ],
      backgroundImages: {
        mobile: "/assets/images/home-nine/features-card-bg-black.png",
        desktop: "/assets/images/home-nine/features-card-bg.svg"
      }
    },
    faqs: [
      {
        question: "ERP-integrated last-mile delivery systems",
        answer: "Seamless integration with existing ERP systems to automate dispatch and synchronize logistics operations for efficient last-mile delivery."
      },
      {
        question: "Automated task dispatch powered by microservices",
        answer: "Intelligent microservices that automatically assign and optimize delivery routes and tasks."
      },
      {
        question: "Centralized data lakes for analytics and operational insights",
        answer: "Centralized data management providing insights for route optimization, inventory management, and strategic planning."
      }
    ]
  },
  {
    id: 3,
    slug: "enterprise",
    title: "Enterprise & Conglomerates",
    subtitle: "Enterprise & Conglomerates",
    description:
      "Driving digital transformation at scale with cloud, automation, and enterprise-grade solutions.",
    detailedDescription:
      "Enterprises and conglomerates operate across multiple sectors and geographies, managing vast systems, workforces, and operations. Their size requires robust, scalable, and secure digital strategies.",
    imagePosition: "left",
    link: "/industry/enterprise",
    image: "/assets/images/600x400-2.webp",
    workProcess: {
      pillName: "Key Challenges",
      heading: "Why it matters / key challenges",
      processSteps: [
        {
          id: 1,
          title: "Legacy System Modernization",
          description: "Large organizations often face challenges in modernizing legacy systems, coordinating across subsidiaries, managing risk, and scaling innovation quickly without disrupting operations.",
          icon: "01"
        },
        {
          id: 2,
          title: "Cross-Subsidiary Coordination", 
          description: "Enterprises need unified platforms that can coordinate operations across multiple subsidiaries and geographies while maintaining efficiency and consistency.",
          icon: "02"
        },
        {
          id: 3,
          title: "Scaling Innovation Without Disruption",
          description: "Digital transformation must happen without disrupting critical business operations, requiring careful planning and execution strategies.",
          icon: "03"
        }
      ],
      imageSrc: "/assets/images/industries/Key Challenges 3.webp",
      parallaxElements: [
        {
          depth: "0.30",
          content: "Legacy Modernization",
          type: "badge",
          color: "bg-[#4A7DFF]"
        },
        {
          depth: "0.40", 
          content: "/assets/images/industries/Etherium-2.webp",
          type: "image"
        },
        {
          depth: "0.20",
          content: "Business Continuity", 
          type: "badge",
          color: "bg-it-blue"
        }
      ]
    },
    features: {
      headerContent: {
        title: "How your company fits in",
        description: "Impera partners with enterprises and conglomerates to deliver end-to-end cloud migration strategies, automation of mission-critical processes, and unified platforms that increase efficiency, resilience, and agility across global operations."
      },
      cards: [
        {
          id: 1,
          icon: "Cloud",
          title: "Cloud Migration & Modernization",
          description: "End-to-end migration solutions from legacy and on-premise systems to secure, scalable cloud platforms with enterprise resilience and agility.",
          link: "/services",
          aosDelay: 0
        },
        {
          id: 2,
          icon: "Modernization",
          title: "Enterprise Unified Infrastructure",
          description: "Design and deployment of unified, enterprise-grade cloud architectures that enhance reliability, scalability, and operational efficiency across global operations.",
          link: "/services",
          aosDelay: 200
        },
        {
          id: 3,
          icon: "Mission",
          title: "Mission-Critical Intelligent Automation",
          description: "Automation of core enterprise processes to improve accuracy, reduce manual dependencies, and increase operational agility at scale.",
          link: "/services",
          aosDelay: 400
        }
      ],
      
      backgroundImages: {
        mobile: "/assets/images/home-nine/features-card-bg-black.png",
        desktop: "/assets/images/home-nine/features-card-bg.svg"
      }
    },
    faqs: [
      {
        question: "AWS migration strategies with minimal downtime",
        answer: "Comprehensive migration strategies covering environment setup, continuous replication, testing, and planned cutovers to minimize business disruption."
      },
      {
        question: "Process modeling and low-code applications for rapid innovation",
        answer: "Rapid development and deployment of business applications through process modeling and low-code platforms that enable quick innovation without extensive development cycles."
      },
      {
        question: "End-to-end workflow automation across business units",
        answer: "Unified workflow automation solutions that streamline operations across all business units, increasing efficiency and reducing manual overhead."
      }
    ]
  },
];

export default industriesData;

